import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { StyledDropdown, StyledLanguageIcon, StyledLanguageOption, StyledLanguageToggle } from 'src/common/components/language-toggle/language-toggle.styles';
import { SupportedLanguage, useLanguage } from 'src/common/contexts/language-context';
export const LanguageToggle: React.FC = () => {
  const {
    currentLanguage,
    setLanguage
  } = useLanguage();
  const [isOpen, setIsOpen] = React.useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);
  const languages = [{
    code: SupportedLanguage.ENGLISH,
    label: 'English',
    flag: '🇬🇧'
  }, {
    code: SupportedLanguage.FRENCH,
    label: 'Français',
    flag: '🇫🇷'
  }];
  const handleLanguageChange = (languageCode: SupportedLanguage) => {
    setLanguage(languageCode);
    setIsOpen(false);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return <StyledLanguageToggle ref={dropdownRef} data-sentry-element="StyledLanguageToggle" data-sentry-component="LanguageToggle" data-sentry-source-file="language-toggle.tsx">
      <StyledLanguageIcon onClick={toggleDropdown} aria-label="Change language" data-testid="language-toggle-button" data-sentry-element="StyledLanguageIcon" data-sentry-source-file="language-toggle.tsx">
        <FontAwesomeIcon icon={faGlobe} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="language-toggle.tsx" />
      </StyledLanguageIcon>

      <StyledDropdown isOpen={isOpen} data-testid="language-dropdown" data-sentry-element="StyledDropdown" data-sentry-source-file="language-toggle.tsx">
        {languages.map(language => <StyledLanguageOption key={language.code} onClick={() => handleLanguageChange(language.code)} isSelected={language.code === currentLanguage} data-testid={`language-option-${language.code}`}>
            <div>
              <span>{language.flag}</span>
              <span style={{
            paddingLeft: '0.5rem'
          }}>{language.label}</span>
            </div>
          </StyledLanguageOption>)}
      </StyledDropdown>
    </StyledLanguageToggle>;
};